export default function getPrice(item, showNetPrice = false, property = 'price') {
  const { currency } = item;
  const value = (showNetPrice ? (item.originalPrice ?? 0) : (item[property] ?? item.price ?? 0)).toLocaleString('de-DE');
  return `${value} ${CURRENCY_SYMBOLS[currency] ?? currency}`;
}

const CURRENCY_SYMBOLS = {
  EUR: '€',
};
